const e = (t) => (t.setHours(23, 59, 59, 999), t);
export {
  e as setDateTill
};
